import { Role } from './roles'

export const SaleModifyRoles = [
  Role.SALES_OFFICER,
  Role.SALES_SUPERVISOR,
  Role.ADMIN,
  Role.ADMIN_CKD,
]

export const SaleCancelRoles = [
  Role.SALES_SUPERVISOR,
  Role.ADMIN,
  Role.ADMIN_CKD,
]

export const SaleViewRoles = [
  Role.WAREHOUSE_SUPERVISOR,
  Role.WAREHOUSE_OFFICER,
  Role.PURCHASE_SUPERVISOR,
  Role.PURCHASE_OFFICER,
  Role.QC_SUPERVISOR,
  Role.QC_OFFICER,
  Role.PRODUCTION_SUPERVISOR,
  Role.PRODUCTION_TECHNICIAN,
  Role.PRODUCTION_OFFICER,
  Role.PLANNING_SUPERVISOR,
  Role.PLANNING_OFFICER,
  Role.ACCOUNTING_SUPERVISOR,
  Role.ACCOUNTING_OFFICER,
  ...SaleModifyRoles,
  Role.QSS_OFFICER,
]

export const SaleViewWo1010Roles = [
  Role.PRODUCTION_SUPERVISOR,
  Role.PRODUCTION_TECHNICIAN,
  Role.PLANNING_SUPERVISOR,
  Role.PLANNING_OFFICER,
  ...SaleModifyRoles,
  Role.QSS_OFFICER,
]

export const SaleForecastRoles = [
  Role.SALES_OFFICER,
  Role.SALES_SUPERVISOR,
  Role.ADMIN,
  Role.ADMIN_CKD,
]

export const Sale1010ViewRoles = [
  Role.ADMIN_CKD,
  Role.SALES_OFFICER,
  Role.SALES_SUPERVISOR,
  Role.QSS_OFFICER,
]

export const Sale1020ViewRoles = [
  Role.ADMIN_CKD,
  Role.WAREHOUSE_SUPERVISOR,
  Role.WAREHOUSE_OFFICER,
  Role.PURCHASE_SUPERVISOR,
  Role.PURCHASE_OFFICER,
  Role.QC_SUPERVISOR,
  Role.QC_OFFICER,
  Role.PRODUCTION_SUPERVISOR,
  Role.PRODUCTION_TECHNICIAN,
  Role.PRODUCTION_OFFICER,
  Role.PLANNING_SUPERVISOR,
  Role.PLANNING_OFFICER,
  Role.ACCOUNTING_SUPERVISOR,
  Role.ACCOUNTING_OFFICER,
  ...SaleModifyRoles,
  Role.QSS_OFFICER,
]

export const Sale1030Roles = [
  Role.ADMIN_CKD,
  Role.SALES_OFFICER,
  Role.SALES_SUPERVISOR,
  Role.ADMIN,
  Role.QSS_OFFICER,
]

export const Sale2215ViewRoles = [
  Role.ADMIN_CKD,
  Role.SALES_OFFICER,
  Role.SALES_SUPERVISOR,
  Role.QSS_OFFICER,
]
